import { useEffect } from 'react'

const _useEffect = (func = () => null, deps = []) => useEffect(func, deps)

export default _useEffect
